import { useLanguage } from '../utils/LanguageContext';
import { ValidatedForm, FormSubmit, FormInput } from './common/ValidatedForm';
import { updateUserTaxIdClientSchema } from '../shared/validations/userValidations';
import translations from '../components/ComponentsTranslations.lang.json';
import { useAuth } from '../utils/AuthContext.js';

const SSN_ITIN = ({ onFinish }) => {
  const { lang } = useLanguage(translations);
  const { api } = useAuth();

  return (
    <ValidatedForm schema={updateUserTaxIdClientSchema} handleSubmit={api.updateUserTaxId} onFinish={onFinish}>
      <FormInput name="taxId" type="text" />
      <FormSubmit>{lang('next')}</FormSubmit>
    </ValidatedForm>
  );
};

export default SSN_ITIN;
